import http from '../../assets/js/http.js' //封装axios

// 小仓库
const state = {
    dictList: {}
};
const mutations = {
    GETDICTARR(state, data) {
        state.dictList = data;
    },
};

const actions = {
    // 向服务器获取数据
    getdictList({
        commit
    }) {
        const dictArr = "建筑布局,屋瓦,屋顶,雀替纹样,柱子形式,柱子材料,柱础,柱面装饰,屋脊装饰,建筑支撑结构,窗户样式,建筑结构类型,迁徙原因类型,保存状况,损坏原因类型,铺地,屋脊,墙体材料,妈祖庙父庙,文章分类";
        let parData = {
            dictList: dictArr,
        };

        http.From("/dict/getDictList", parData).then((res) => {
            if (res.code == "0") {
                commit("GETDICTARR", res.data);
                //存储字典信息
                sessionStorage.setItem("dict", JSON.stringify(res.data));
            } else {}
        });
    },

};
const getters = {
    bulidLayout(state) {

        return state.dictList['建筑布局'] || JSON.parse(sessionStorage.getItem("dict"))['建筑布局'] || [];
    },
    watts(state) {
        return state.dictList['屋瓦'] || JSON.parse(sessionStorage.getItem("dict"))['建筑布局'] || [];
    },
    roof(state) {
        return state.dictList['屋顶'] || JSON.parse(sessionStorage.getItem("dict"))['建筑布局'] || [];
    },
    texture(state) {
        return state.dictList['雀替纹样'] || JSON.parse(sessionStorage.getItem("dict"))['雀替纹样'] || [];
    },
    pillarsStyle(state) {
        return state.dictList['柱子形式'] || JSON.parse(sessionStorage.getItem("dict"))['柱子形式'] || [];
    },
    pillarsMaterial(state) {
        return state.dictList['柱子材料'] || JSON.parse(sessionStorage.getItem("dict"))['柱子材料'] || [];
    },
    pillarsBasis(state) {
        return state.dictList['柱础'] || JSON.parse(sessionStorage.getItem("dict"))['柱础'] || [];
    },
    pillarsDecoration(state) {
        return state.dictList['柱面装饰'] || JSON.parse(sessionStorage.getItem("dict"))['柱面装饰'] || [];
    },
    ridgeDecoration(state) {
        return state.dictList['屋脊装饰'] || JSON.parse(sessionStorage.getItem("dict"))['屋脊装饰'] || [];
    },
    support(state) {
        return state.dictList['建筑支撑结构'] || JSON.parse(sessionStorage.getItem("dict"))['建筑支撑结构'] || [];
    },
    window(state) {
        return state.dictList['窗户样式'] || JSON.parse(sessionStorage.getItem("dict"))['窗户样式'] || [];
    },
    buildType(state) {
        return state.dictList['建筑结构类型'] || JSON.parse(sessionStorage.getItem("dict"))['建筑结构类型'] || [];
    },
    migrationType(state) {
        return state.dictList['迁徙原因类型'] || JSON.parse(sessionStorage.getItem("dict"))['迁徙原因类型'] || [];
    },
    saveStatr(state) {
        return state.dictList['保存状况'] || JSON.parse(sessionStorage.getItem("dict"))['保存状况'] || [];
    },
    damageType(state) {
        return state.dictList['损坏原因类型'] || JSON.parse(sessionStorage.getItem("dict"))['损坏原因类型'] || [];
    },
    floor(state) {
        return state.dictList['铺地'] || JSON.parse(sessionStorage.getItem("dict"))['铺地'] || [];
    },
    ridge(state) {
        return state.dictList['屋脊'] || JSON.parse(sessionStorage.getItem("dict"))['屋脊'] || [];
    },
    wallType(state) {
        return state.dictList['墙体材料'] || JSON.parse(sessionStorage.getItem("dict"))['墙体材料'] || [];
    },
    fatherTemple(state) {
        return state.dictList['妈祖庙父庙'] || JSON.parse(sessionStorage.getItem("dict"))['妈祖庙父庙'] || [];
    },

    titleClass(state) {
        return state.dictList['文章分类'] || JSON.parse(sessionStorage.getItem("dict"))['文章分类'] || [];
    },
    dynastyList(state) {
        return state.dictList['朝代'] || JSON.parse(sessionStorage.getItem("dict"))['朝代'] || [];
    },
};

export default {
    state,
    mutations,
    actions,
    getters
}